<template>
  <a-modal
    width="600px"
    title="上传数据"
    v-model:visible="visible"
    :confirm-loading="confirmLoading"
  >
    <a-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-item label="名称" name="uploadNote">
        <a-input
          v-model:value="form.uploadNote"
          placeholder="1~24个字符，可包含大小写字母、数字、中文、下划线"
          autocomplete="off"
        />
      </a-form-item>
      <a-form-item label="数据类型" name="itemTypeId">
        <a-select v-model:value="form.itemTypeId">
          <!-- <a-select-option key="">
            全部
          </a-select-option> -->
          <a-select-option v-for="t in dataTypeList2" :key="t.id">
            {{ t.chineseInstructions }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="数据属性">
        <a-tree-select
          v-model:value="attrValue"
          style="width: 120px"
          treeNodeLabelProp="chineseInstructions"
          :tree-data="dataAttrData"
          tree-checkable
          search-placeholder="请选择"
        />
      </a-form-item>
      <a-form-item label="tag标注">
        <a-select
          mode="multiple"
          style="width: 120px"
          v-model:value="tagValue"
          placeholder="请选择"
        >
          <a-select-option v-for="i in allTags" :key="i.id">
            {{ i.chineseInstructions }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="路径" name="location">
        <a-input disabled v-model:value="form.location" autocomplete="off" />
        <path-choose ref="pc" @update="setPath"></path-choose>
        <!-- <a-select v-model:value="form.location">
          <a-select-option
            v-for="item in fileList"
            :key="item.sourceName">
            {{ item.name }}
          </a-select-option>
        </a-select> -->
        <a-button type="primary" class="mt10" @click="pathOpen"
          >选择路径</a-button
        >
        <!-- <a :href="cloudFileUrl" target="_blank">
          <a-button type="primary" class="mt10">新增上传</a-button>
        </a> -->
      </a-form-item>
    </a-form>
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel"> 取消 </a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="confirmLoading"
        @click="handleOk"
      >
        确认
      </a-button>
    </template>
  </a-modal>
</template>
<script>
import { addUpload } from "@/api/uploadRecord";
import { mapState } from "vuex";
import PathChoose from "./pathChoose.vue";
export default {
  components: {
    PathChoose,
  },
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    allTags: {
      type: Array,
      default: () => [],
    },
    dataAttrData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const checkName = async (_, value) => {
      const regexp = /^[\u4e00-\u9fa5A-Za-z0-9_-]{1,512}$/;
      if (!regexp.test(value)) {
        return Promise.reject(new Error("名称格式不合法"));
      } else {
        return Promise.resolve();
      }
    };
    return {
      cloudFileUrl: "https://storage.wellspiking.ai/web/client/files", // window.publicConfig.cloudFileUrl
      visible: false,
      confirmLoading: false,
      dataTypeList2: [
        {
          id: "1",
          chineseInstructions: "labelme_json", //多边形
          englishInstructions: "polygon",
        },
        {
          id: "2",
          chineseInstructions: "labelimg_xml", //矩形框
          englishInstructions: "object_detection",
        },
      ],
      form: {
        uploadNote: "",
        location: "",
        itemTypeId: "",
      },
      rules: {
        uploadNote: [
          { required: true, message: "请选择上传名称", trigger: "blur" },
          { validator: checkName, trigger: "blur" },
        ],
        location: [
          { required: true, message: "请选择上传数据", trigger: "blur" },
        ],
      },
      attrValue: [], // 数据属性筛选
      tagValue: [], // tag筛选
    };
  },
  computed: {
    ...mapState(["userInfo", "dataTypeList"]),
  },
  methods: {
    open() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      });
    },
    pathOpen() {
      this.$refs.pc.open();
    },
    setPath(val) {
      this.form.location = val;
      debugger;
      this.$forceUpdate();
    },
    handleOk() {
      this.$refs.form
        .validate()
        .then(() => {
          addUpload({
            ...this.form,
            itemValueIdList: this.attrValue.join(","),
            tagIdList: this.tagValue.join(","),
            createUserId: this.userInfo.userId,
          })
            .then((res) => {
              this.$message.success("上传成功");
              this.$emit("update");
              this.visible = false;
            })
            .catch((e) => {
              this.$message.error("上传失败");
            });
        })
        .catch((e) => {
          console.log("error submit");
        });
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.tips {
  margin-left: 20px;
  font-size: 12px;
  color: #666;
  vertical-align: sub;
}
</style>
